var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fullscreen-modal',{attrs:{"show-close-button":false}},[_c('div'),(_vm.isLoading)?_c('spinner-loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }